import { ActionTree } from 'vuex'
import ExamAPI from '../api/ExamAPI'
import UploadAPI from '../api/UploadAPI'
import ImportAPI from '../api/ImportAPI'
import { ImportState } from './types'
import { RootState } from '../types'

export const actions: ActionTree<ImportState, RootState> = {
  async loadData ({ commit, state }) {
    const data = await ImportAPI.loadDataAsyn()
    commit("loadData", data)
  },

  async uploadFile ({ commit, state }, payload) {
    if (payload.file){
      const response = await UploadAPI.uploadQuestionFile(state.exam, { file: payload.file})

      if(response.errors){
        if(response.errors["base"]){
          if(document.getElementById("errors"))
            document.getElementById("errors").remove()
          if(document.getElementsByClassName("alert")[0])
            document.getElementsByClassName("alert")[0].remove()
          let errors = ""
          response.errors["base"].forEach((error)=>{
            errors += error + "<br>"
          })
          let newError = document.createElement('div')
          newError.setAttribute("id", "errors");
          newError.innerHTML = `
            <div class="alert alert-warning alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              ${errors}
            </div>
          `

          let main_content = document.getElementsByClassName("container-fluid")[0]
          let container = main_content.parentElement
          container.insertBefore(newError, main_content)
        }
      }
      else{
        commit("loadQuestions", response)
      }

      if(state.questions.length == 0) return
      const questionParams = state.questions.map((question, index) => {
        return question.toParams
      })

      await ExamAPI.update(state.exam, { questionParams })
      window.location.reload();
    }
  },
}
